import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient';
import { useQueryDownloader } from '@trinity/chat-components/containers/QueryDownloader/hooks/index';
import { useActiveBrandIdentifier } from '@trinity/chat-components/containers/UserBrands/useActiveBrandIdentifier';

type Params = {
  kol: {
    id: number;
    name: string;
  };
};

export const useDownloadKolProfile = (params: Params) => {
  const brandIdentifier = useActiveBrandIdentifier();

  const apiClient = useChatApiClient();

  return useQueryDownloader({
    queryKey: [
      `kol-profile:download`,
      params.kol.id,
    ],
    queryFn: ({ queryKey: [, kolId] }) => {
      return apiClient.kolSearch.downloadKolProfile({ kolId: kolId, brandIdentifier });
    },
    meta: {
      downloader: true,
    },
    downloaderOptions: {
      onResponse: res => ({
        filename: `HCP 360 Profile: ${params.kol.name}.docx`,
        type: 'blob',
        value: res.data,
      }),
    },
  });

};